// extracted by mini-css-extract-plugin
module.exports = {"RegisterPage":"RegisterPage_RegisterPage__3UCr-","main":"RegisterPage_main__2uvNf","hiddenValidator":"RegisterPage_hiddenValidator__nZRMn"};